import z from "zod/v3";

export const trashGridTypeSchema = z.enum(["record", "calendar", "place"]);

export const calendarDataSchema = z.object({
  id: z.coerce.string(),
  title: z.string().optional(),
  start: z.string(),
  description: z.string().optional(),
  title_en: z.string().optional(),
  title_zh: z.string().optional(),
  title_cn: z.string().optional(),
  end: z.coerce.string(),
  calendarIds: z.array(z.number()).optional(),
  placeId: z.number().optional(),
  tag: z.string().optional(),
  classNames: z.string().optional(),
  display: z.string().optional(),
  is_annual_leave: z.boolean().optional(),
  allDay: z.boolean().optional(),
});

export const modalInputPropSchema = z.object({
  label: z.string().optional(),
  placeholder: z.string().optional(),
  value: z.string().or(z.number()).optional(),
  setValueFunc: z.function().args(z.string().or(z.number())).returns(z.void()),
  invalid: z.boolean().optional(),
  invalidMsg: z.string().optional(),
  md: z.number().optional(),
});

export type ModalInputProp = z.infer<typeof modalInputPropSchema>;
export type CalendarData = z.infer<typeof calendarDataSchema>;
export type TrashGridType = z.infer<typeof trashGridTypeSchema>;
